import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function WesternSaharaMetatrader4BrokerageLicense() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.western-sahara-metatrader-4-brokerage-license.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/western-sahara-metatrader-4-brokerage-license"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/western-sahara-metatrader-4-brokerage-license.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('launch.title')}
                        subtitle={tp('launch.subtitle')}
                        blocks={[{ items: obj('launch.items') }]}
                        end={tp('launch.end')}
                    />

                    <LocationTimeline
                        title={tp('included.title')}
                        subtitle={tp('included.subtitle')}
                        item={obj('included.item')}
                    />

                    <InfoBlocks
                        title={tp('package.title')}
                        blocks={obj('package.blocks')}
                    />

                    <FeatureCards
                        title={tp('mt4.title')}
                        subtitle={tp('mt4.subtitle')}
                        features={obj('mt4.features')}
                        end={tp('mt4.end')}
                    />

                    <WhySection
                        title={tp('who.title')}
                        subtitle={tp('who.subtitle')}
                        blocks={[{ items: obj('who.items') }]}
                    />

                    <TimelineSection
                        title={tp('process.title')}
                        items={obj('process.items')}
                    />

                    <DetailsSection
                        title={tp('whyUs.title')}
                        subtitle={tp('whyUs.subtitle')}
                        items={obj('whyUs.items')}
                    />

                    <InfoBlocks
                        title={tp('optional.title')}
                        subtitle={tp('optional.subtitle')}
                        blocks={obj('optional.blocks')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />

                    <DetailsSection
                        title={tp('considerations.title')}
                        items={obj('considerations.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
